<template>
  <el-row>
    <Comment
      v-for="(commentModel, index) in dataModels"
      :key="index"
      :data="data"
      :element="element"
      :model="dataModels"
      :index="index"
      :rules="rules"
      :remote="remote"
      :disabled="true"
    />
  </el-row>
</template>

<script>
import { advancedComponents } from '../advanced/advanced.js'
import Comment from './index.vue'
export default {
  name: 'comment-readonly',
  props: [
    'data',
    'element',
    'model',
    'rules',
    'remote',
    'nodeConfig',
    'currentUser',
  ],
  components: {
    Comment,
  },
  data() {
    return {
      advancedComponents,
      dataModels: this.model || [],
      readCommentModel: {},
    }
  },
  watch: {
    model: {
      deep: true,
      handler() {
        this.dataModels = this.model
      },
      immediate: true,
    },
    dataModels: {
      deep: true,
      handler(val) {
        if (!val.length && !this.element.options.showOthersComment) {
          this.renderFormNodeConfig(this.element.list)
          this.dataModels.splice(0, 1, this.readCommentModel)
        }
        this.$emit('update:model', val)
      },
      immediate: true,
    },
  },
  computed: {
    config() {
      return this.data.config
    },
    datalist() {
      if (this.element.options.showOthersComment) {
        return this.dataModels.slice(0, this.dataModels.length - 1)
      }
      return this.dataModels
    },
  },
  methods: {
    renderFormNodeConfig(list) {
      // 渲染设置流程节点配置项
      if (this.nodeConfig) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].type === 'grid') {
            list[i].columns.forEach(item => {
              if (item.list) this.renderFormNodeConfig(item.list)
            })
          } else if (Object.keys(this.nodeConfig).indexOf(list[i].model) >= 0) {
            // 找到对应字段
            const nodeConfig = this.nodeConfig[list[i].model]
            if (nodeConfig) {
              this.editModule(list[i], nodeConfig)
              const model = list[i].model
              const value = this.currentUser[nodeConfig.initial]
              this.$set(this.readCommentModel, model, value)
            }
          }
        }
      }
    },
    editModule(moduleObj, obj) {
      if (obj.required !== 'none') {
        // 必填
        let isRequired = false
        if (obj.required === 'true') {
          isRequired = true
          moduleObj.options.required = true
        } else if (obj.required === 'false') {
          moduleObj.options.required = false
        }
        if (moduleObj.rules && moduleObj.rules.length > 0) {
          for (let j = 0; j < moduleObj.rules.length; j++) {
            if (
              Object.prototype.hasOwnProperty.call(
                moduleObj.rules[j],
                'required'
              )
            ) {
              if (!moduleObj.options.required) {
                moduleObj.rules.splice(j, 1)
              } else {
                moduleObj.rules[j].required = true
                moduleObj.rules[j].message = moduleObj.name + '必须填写'
                isRequired = !isRequired
              }
            }
          }
        } else {
          moduleObj.rules = []
        }
        if (isRequired) {
          const rule = {
            required: true,
            message: moduleObj.name + '必须填写',
          }
          moduleObj.rules.push(rule)
        }
      }
      if (obj.disable !== 'none') {
        // 禁用
        if (obj.disable === 'true') {
          moduleObj.options.disabled = true
        } else if (obj.disable === 'false') {
          moduleObj.options.disabled = false
        }
      }

      if (obj.hidden !== 'none') {
        // 隐藏
        if (obj.hidden === 'true') {
          moduleObj.options.hidden = true
        } else if (obj.hidden === 'false') {
          moduleObj.options.hidden = false
        }
      } else {
        moduleObj.options.hidden = false
      }
      // 红色高亮
      if (obj.stress === 'true') {
        moduleObj.options.stress = true
      } else if (obj.stress === 'false') {
        moduleObj.options.stress = false
      }
    },
  },
}
</script>
